<template>
  <account-profile />
</template>

<script>
import AccountProfile from "@/components/3pl/Settings/AccountProfile/index";
export default {
  components: {
    AccountProfile,
  },
};
</script>

<style></style>
